import React from 'react';
import { useTranslation } from 'react-i18next';
import { GridContainer, GridItem } from '../../visual-components/grid/grid';
import { Spacer } from '../../visual-components/spacer/spacer';
import { Typography } from '../../visual-components/typography/typography';
import { Link } from '../../visual-components/link/link';
import { PageContainer } from '../page-container/page-container';
import { usePathBuilder } from '../../core/routing/hooks/use-path-builder';

export const NotFoundView: React.FC = () => {
  const { t } = useTranslation();
  const { homePath } = usePathBuilder();

  return (
    <PageContainer documentTitle={t('notFound.documentTitle')}>
      <GridContainer>
        <GridItem>
          <Typography variant="headline-1">{t('notFound.documentTitle')}</Typography>
          <Spacer size="06" />
          <Typography variant="maintext">{t('notFound.pageNotFoundDescription')}</Typography>
          <Spacer size="03" />
          <Link icon="arrow-right" iconPosition="right" to={homePath()}>
            {t('global.backToHome')}
          </Link>
        </GridItem>
      </GridContainer>
    </PageContainer>
  );
};
